<div [id]="chartId$ | async" class="chart-container"></div>
